<div *ngIf="loading" class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10">
    <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
    <mat-spinner></mat-spinner>
</div>

<div class="bg-gray-100 pb-10">
    <div class="p-2 md:p-10" style="width: 90%; max-width: 56rem; margin-left: auto; margin-right: auto;">
        
        <!-- Sección de Cambio de Contraseña -->
        <div class="p-6 md:p-10 bg-white shadow-md rounded-3xl">
            <h1 class="text-black font-semibold text-xl md:text-2xl mb-6 text-center">Cambio de Contraseña</h1>
            <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" class="space-y-6">

                <div *ngIf="apiSuccessMessage" class="font-bold text-white rounded-lg bg-green-500 py-2 px-5 text-center mt-5">
                    {{ apiSuccessMessage }}
                </div>
                
                <div *ngIf="apiErrorMessage" class="font-bold text-white rounded-lg bg-red-500 py-2 px-5 text-center mt-5">
                    {{ apiErrorMessage }}
                </div>
    
                <div *ngIf="resetPasswordForm.errors?.mismatch && (resetPasswordForm.get('confirmPassword').touched || resetPasswordForm.get('newPassword').touched)" class="text-red-500 text-xs mt-2">
                    <p class="text-red-500">Las contraseñas no coinciden.</p>
                </div>
    
                <!-- Campo Nueva Contraseña -->
                <div>
                    <label for="newPassword" class="block text-gray-700 text-sm font-bold mb-2">Nueva Contraseña</label>
                    <input id="newPassword" type="password" formControlName="newPassword" 
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                    
                    <!-- Mensajes de error para la Nueva Contraseña -->
                    <div *ngIf="resetPasswordForm.get('newPassword').touched && resetPasswordForm.get('newPassword').errors" class="text-red-500 text-xs mt-2">
                        <div *ngIf="resetPasswordForm.get('newPassword').errors['required']">
                        La contraseña es obligatoria.
                        </div>
                        <div *ngIf="resetPasswordForm.get('newPassword').errors['minlength']">
                        La contraseña debe tener al menos 8 caracteres.
                        </div>
                        <div *ngIf="resetPasswordForm.get('newPassword').errors['pattern']">
                        La contraseña debe contener al menos una mayúscula y un número.
                        </div>
                    </div>
                    
                    
                </div>
    
                <!-- Campo Confirmar Nueva Contraseña -->
                <div>
                    <label for="confirmPassword" class="block text-gray-700 text-sm font-bold mb-2">Confirmar Nueva Contraseña</label>
                    <input id="confirmPassword" type="password" formControlName="confirmPassword" 
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                    
                    <!-- Mensajes de error para Confirmar Nueva Contraseña -->
                    
                    <div *ngIf="resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('confirmPassword').errors" class="text-red-500 text-xs mt-2">
                        <div *ngIf="resetPasswordForm.get('confirmPassword').errors['required']">
                            Confirmar la contraseña es obligatorio.
                        </div>
                    </div>
                </div>
    
                <!-- Botón de envío -->
                <div class="flex justify-end">
                    <button type="submit" [disabled]="resetPasswordForm.invalid || loading"
                            class="appearAlpha cursor-pointer bg-primary font-medium rounded-3xl px-8 py-2 text-white flex items-center hover:bg-secondary transition ease-linear text-sm">
                        Cambiar Contraseña
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
